import React from "react";
import "./topbar.css";
import { NotificationsNone, Language, Settings } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";


export default function Topbar() {
  const history = useHistory();

  const userData = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;
  const profileData = localStorage.getItem('profileInfo') ? JSON.parse(localStorage.getItem('profileInfo')) : null;


  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("profileInfo");
    history.push('/login');
  }

  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft">
          <Typography component="h2" style={{fontSize: '25px', fontWeight: '500'}}>
            GroupBuy SG
          </Typography>
        </div>
        <div className="topCenter">
        </div>
        <div className="topRight">
          <div className="userRol">
            {userData?.role}
          </div>
          <div onClick={handleLogout} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
            {profileData?.profile_image === undefined ?
              <img src="https://www.bastiaanmulder.nl/wp-content/uploads/2013/11/dummy-image-square.jpg" className="topAvatar" />
              :
              <img src={`${process.env.React_App_baseURL}/uploads/${profileData.profile_image}`} alt="profile" className="topAvatar" />
            }
            Logout
          </div>
        </div>
      </div>
    </div>
  );
}
